import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge Tailwind classes safely; the one class helper the codebase uses. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
